/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, Keyboard, A11y, FreeMode, Thumbs} from 'swiper/modules';

(($) => {

    //ORIGIONAL TESTIMONIALS SLIDESHOW - homepage
    const origTestimonials = document.querySelectorAll('.orig-testimonials');
    origTestimonials.forEach((testSlideshow, index) => {

        let slider = testSlideshow.querySelector('.js-orig-testimonials');
        let prev = testSlideshow.querySelector('.swiper-button-prev');
        let next = testSlideshow.querySelector('.swiper-button-next');

        //TESTIMONIAL SLIDESHOW
        const origTestimonialSwiper = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y],
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            }
        });

    });


    //CARD SWIPER - new templates
    const swipers = document.querySelectorAll('.card-swiper');
    const swiperPagination = document.querySelectorAll('.swiper-pagination');
    const swiperPrev = document.querySelectorAll('.swiper-button-prev');
    const swiperNext = document.querySelectorAll('.swiper-button-next');

    swipers.forEach((slider, index) => {

        //if (slider.classList.contains('card-swiper')) {

            const cardSwiper = new Swiper(slider, {
                modules: [Navigation, Pagination, Keyboard, A11y],
                slidesPerView: 1,
                spaceBetween: 25,
                speed: 1000,
                loop: true,
                loopAdditionalSlides: 1,
                keyboard: {
                    enabled: true
                },
                pagination: {
                    el: swiperPagination[index],
                    type: "progressbar"
                },
                navigation: {
                    prevEl: swiperPrev[index],
                    nextEl: swiperNext[index]
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 60,
                    }
                }
            });
        //}
    });


    //SLIDESHOW w/ THUMBNAILS (used on WCP Cares template)
    const galleries = document.querySelectorAll('.thumbnail-gallery');

    galleries.forEach((gallery, index) => {

        let slider = gallery.querySelector('.thumbnail-gallery__slideshow');
        let thumbs = gallery.querySelector('.thumbnail-gallery__thumbs');
        let prev = gallery.querySelector('.swiper-button-prev');
        let next = gallery.querySelector('.swiper-button-next');

        const galleryThumbs = new Swiper(thumbs, {
            modules: [FreeMode],
            spaceBetween: 5,
            slidesPerView: 2,
            loop: false,
            freeMode: true,
            breakpoints: {
                530: {
                    slidesPerView: 3,
                },
                800: {
                    slidesPerView: 4,
                },
                1024: {
                    slidesPerView: 5,
                }
            }
        });

        const galleryTop = new Swiper(slider, {
            modules: [EffectFade,Navigation,A11y,Thumbs],
            loop: false,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    });

})(jQuery)